import React, { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Settings as SettingsIcon, MessageSquare, Plus, Search, BookOpen, User, LogOut } from 'lucide-react';
import { useAppStore } from '../store/useAppStore';
import { useTranslations } from '../hooks/useTranslations';

const Sidebar = ({ onOpenSettings }) => {
  const { 
    sidebarOpen, setSidebarOpen, theme, setTheme, user, logout,
    loading, setLoading, sessions, loadSession, deleteSession, createSession, currentSessionId
  } = useAppStore();
  const { t } = useTranslations();

  const [savedSessions, setSavedSessions] = useState([])

  useEffect(() => {
    console.log('update sesssions', sessions)

    let result = []
    for (let session in sessions) {
      result.push({
        id: sessions[session].id,
        title: "Session #" + String(sessions[session].id),
        preview: "Enhanced ...",
        date: sessions[session].created
      })
    }
    setSavedSessions(result.reverse())
  }, [sessions]);

  const handleThemeToggle = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    console.log('Theme changed to:', newTheme);
  };

  const handleLoadSession = async (e, chat)  => {
    e.stopPropagation(); 
    await setLoading(true);
    await loadSession(chat.id);
    await setLoading(false);
  }

  return (
    <motion.div
      className={`sidebar ${sidebarOpen ? 'open' : 'collapsed'}`}
      initial={{ x: -280 }}
      animate={{ x: sidebarOpen ? 0 : -280 }}
      transition={{ 
        duration: 0.25, 
        ease: [0.4, 0, 0.2, 1],
        type: "tween"
      }}
      style={{ 
        willChange: 'transform',
        backfaceVisibility: 'hidden',
        perspective: 1000 
      }}
    >

      <div className="sidebar-header">
        <div className="sidebar-nav">
          <button className="nav-btn" disabled={loading} onClick={async () => {
            await createSession();
            console.log('New chat started - cleared all state');
          }}>
            <Plus size={16} />
            <span>{t('newChat')}</span>
          </button>
        </div>
      </div>
      
      {/* Sidebar Content */}
      <div className="sidebar-content">
        {/* Chats Section */}
        <div className="sidebar-section">
          <h4>{t('chats')}</h4>
          <div className="chats-list">
            {savedSessions.length > 0 ? (
              savedSessions.map((chat) => (
                <div key={chat.id} className={chat.id == currentSessionId ? "chat-item active" : "chat-item"} onClick={(e) => handleLoadSession(e, chat)}>
                  <div className="chat-info">
                    <div className="chat-item-header">
                      <h4>{chat.title}</h4>
                      <button 
                        className="card-btn remove-btn" 
                        title="Delete"
                        onClick={(e) => {
                          e.stopPropagation(); 
                          deleteSession(chat.id)
                        }}
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    </div>
                    <p>{chat.preview}</p>
                  </div>
                  <div className="chat-date">{chat.date}</div>
                </div>
              ))
            ) : (
              <p className="no-chats">{t('noSavedChats')}</p>
            )}
          </div>
        </div>
        
        {/* Theme Toggle Section */}
        <div className="sidebar-section">
          <h4>{t('theme')}</h4>
          <div className="theme-toggle">
            <span>{t('dark')}</span>
            <label className="switch">
              <input 
                type="checkbox" 
                checked={theme === 'light'}
                onChange={handleThemeToggle}
              />
              <span className="slider"></span>
            </label>
            <span>{t('light')}</span>
          </div>
        </div>
      </div>
      
      {/* User Profile Section */}
      {user && (
        <div className="sidebar-user-section">
          <div className="user-profile-info">
            <div className="user-avatar">
              <User size={20} />
            </div>
            <div className="user-details">
              <div className="username">{user.username}</div>
              <div className="user-email">{user.email}</div>
            </div>
          </div>
        </div>
      )}
      
      {/* Sidebar Footer */}
      <div className="sidebar-footer">
        <button className="settings-btn" onClick={onOpenSettings}>
          <SettingsIcon size={16} />
          {t('settings')}
        </button>
      </div>

    </motion.div>
  );
};

export default Sidebar; 